import axios from 'axios';
import qs from 'qs';
import { genericRoute } from '../../routes';

import { USERS_LOGIN_GOOGLE } from '../../constants/actions';
import { dispatchError } from '../../actions/errors';

window.gglAsyncInit = function() {
	window.gapi.load('auth2', function() {
		window.gauth = window.gapi.auth2.init({
			client_id: (window.konfig && window.konfig.social && window.konfig.social.gglAppId) ? window.konfig.social.gglAppId : '921710696389-ip19ev7u4vuu774cfrtnerh4borj8rou.apps.googleusercontent.com',
			cookiepolicy: 'single_host_origin',
			// Request scopes in addition to 'profile' and 'email'
			//scope: 'additional_scope'
		});
	});
};

export default class FBLoader {
	constructor() {
		//this.load();
	}

	load() {
		if (!this.isLoaded()) {
			// Inject google api
			(function(d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = '//apis.google.com/js/api:client.js?onload=gglAsyncInit';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'google-jssdk'));
		}
	}

	isLoaded() {
		return (typeof this.API === 'object');
	}

	get API() {
		return window.gauth;
	}

	login(dispatch) {
		return this._GoogleLogin(genericRoute(false, 'api/account/googlesignin'), dispatch);
	};

	register(dispatch) {
		return this._GoogleLogin(genericRoute(false, 'api/account/googlesignup'), dispatch);
	};

	_GoogleLogin(path, dispatch) {
		if (this.isLoaded()) {
			this.API.signIn({
				scope: 'email',
			})
			.then(function(googleUser) {
				//console.log(googleUser);

				let idToken = googleUser.getAuthResponse().id_token;

				axios.post(path, qs.stringify({
					idtoken: idToken,
				}))
				.then((response) => {
					//console.log('Signed in as: ' + response.data.user.name);

					if (response.data.user) {
						dispatch({
							type: USERS_LOGIN_GOOGLE,
							payload: response.data,
						});
					}
				})
				.catch((response) => {
					dispatch(dispatchError(response.data));
					//console.warn(response);
				});

			}, function(error) {
				dispatch(dispatchError({
					message: 'Google Auth not completed.'
				}));
				console.warn(error);
			});
		} else {
			this.load();
		}
	}
};



/** WEBPACK FOOTER **
 ** ./frontend/utils/social/google.js
 **/